import {UIElement} from "./ui";
import {arrayLast} from "../util";
import '/modules/common/css/ui/modal.css';
import '/modules/common/css/ui/modal.responsive.css';
import {MAX_SMALL_HEIGHT_THRESHOLD, MAX_SMALL_WIDTH_THRESHOLD} from "../config/config";

/**
 * A modal window
 * @extends UIElement
 */
class Modal extends UIElement {

    static openModals = {};
    static openModalsStack = [];

    static getOpenModal(){
        return Modal.openModalsStack.length>0 ? Modal.openModals[arrayLast(Modal.openModalsStack)] : null;
    }

    /**
     *
     * @param target {jQuery} The target element to append the modal to
     * @param id {string} Panel id
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     * @param expandable {boolean} should this modal be expandable to full?
     * @param hasFooter {boolean} should a footer be rendered for this modal?
     */
    constructor(target, id, onChangeRuntimeConfig, expandable, hasFooter=false) {
        super(id, onChangeRuntimeConfig);
        this.target = target;
        this.id = id;
        this.showCallbacks = new Set();
        this.hideCallbacks = new Set();
        this.expandCallbacks = new Set();
        this.expandable = expandable;
        this.footer = hasFooter;
    }

    getUIElement() {
        if (!this.uiElement) {
            const expanded = this.isExpanded();
            const expanderButtonStr = this.expandable
                ? '<button class="modal-expander ' + (expanded ? 'collapse' : 'expand') + '"   type="button" title="' + tumbo.translator.translate('modal.expander.name') + '"></button>'
                : '';

            this.uiElement = $(
                '<div id="' + this.id + '" class="modal-outer' + (expanded ? ' expanded' : '') + (this.hasFooter() ? ' has-footer' : '') + '">' +
                '   <section class="modal-inner" role="dialog" aria-modal="true" aria-labelledby="' + this.id + '_title">' +
                '       <header class="modal-header">' +
                '           <div class="modal-title" id="' + this.id + '_title">' +
                '           </div>' +
                '           <div class="modal-buttons-container">' +
                expanderButtonStr +
                '               <button class="modal-closer" type="button" title="' + tumbo.translator.translate('modal.closer.name') + '"></button>' +
                '           </div>' +
                '       </header>' +
                '       <div class="modal-content"></div>' +
                (this.hasFooter()?'       <footer class="modal-footer"></footer>':'') +
                '   </section>' +
                '</div>'
            );
            $($('.modal-buttons-container button.modal-closer', this.uiElement)[0]).click(() => {
                this.hide();
                this.logStat("HIDE");
            }).attr('aria-controls',this.id);

            if (this.expandable) {
                $($('.modal-buttons-container button.modal-expander', this.uiElement)[0]).click(() => {
                    if (this.isExpanded()) {
                        this.collapse();
                        this.logStat("COLLAPSE");
                    } else {
                        this.expand();
                        this.logStat("EXPAND");
                    }
                }).attr('aria-controls',this.id);
            }

            this.uiElement.addClass(this.getModalClasses());
            this.target.append(this.uiElement);
            this.visible = false;
        }
        return this.uiElement;
    }

    /**
     * Is this modal expanded?
     * @return {boolean}
     */
    isExpanded() {
        return this.expandable && this.getSessionProp("expanded");
    }

    /**
     * Expand this modal
     * @return {Modal} this modal
     */
    expand() {
        if (this.expandable) {
            this.setSessionProp("expanded", true);
            $($('.modal-buttons-container button.modal-expander', this.uiElement)[0])
                .addClass('collapse')
                .removeClass('expand');
            this.uiElement.addClass('expanded');
            this.expandCallbacks.forEach(c => c());
        }
        return this;
    }

    /**
     * Collapse this modal
     * @return {Modal} this modal
     */
    collapse() {
        if (this.expandable) {
            this.setSessionProp("expanded", false);
            $($('.modal-buttons-container button.modal-expander', this.uiElement)[0])
                .addClass('expand')
                .removeClass('collapse');
            this.uiElement.removeClass('expanded');
            this.expandCallbacks.forEach(c => c());
        }
        return this;
    }

    /**
     * Add a callback for when this modal hides
     * @param callback
     * @return {Modal} this modal
     */
    onHide(callback) {
        if(callback)
            this.hideCallbacks.add(callback);
        return this;
    }

    /**
     * Add a callback for when this modal shows
     * @param callback
     * @return {Modal} this modal
     */
    onShow(callback) {
        if(callback)
            this.showCallbacks.add(callback);
        return this;
    }

    /**
     * Add a callback for when this modal expands/collapses (if it is expandable)
     * @param callback
     * @return {Modal} this modal
     */
    onExpandCollapse(callback){
        if(this.expandable && callback)
            this.expandCallbacks.add(callback);
        return this;
    }

    /**
     * Override to define HTML classes for this modal
     * @return {string}
     */
    getModalClasses() {
        return '';
    }

    /**
     * Show this modal
     * @return {Modal} this modal
     */
    show() {
        if (!this.visible) {
            $($('.modal-inner', this.getUIElement().addClass('visible').removeAttr('hidden'))[0]).attr('tabIndex', "0");
            this.visible = true;
            this.showCallbacks.forEach(c => c());
            UIElement.openUIElements.push(this);
            Modal.openModalsStack.push(this.getId());
            Modal.openModals[this.getId()] = this;
        }
        return this;
    }

    /**
     * Hide this modal
     * @return {Modal} this modal
     */
    hide() {
        if (this.visible) {
            $($('.modal-inner', this.getUIElement().removeClass('visible').attr('hidden', ''))[0]).attr('tabIndex', "-1");
            this.visible = false;
            this.hideCallbacks.forEach(c => c());
            UIElement.openUIElements.pop();
            Modal.openModalsStack.splice(Modal.openModalsStack.indexOf(this.getId()),1);
            delete Modal.openModals[this.getId()];
        }
        return this;
    }

    /**
     * Is this modal visible
     * @return {boolean}
     */
    isVisible() {
        return !!this.visible;
    }

    hasFooter(){
        return !!this.footer;
    }

    /**
     * Set the title for this modal
     * @param titleText {string}
     * @return {Modal} this modal
     */
    setTitle(titleText) {
        $($('.modal-title', this.getUIElement())[0]).html(titleText);
        return this;
    }

    /**
     * Set the content for this modal
     * @param elements {jQuery}
     * @return {Modal} this modal
     */
    setContent(elements) {
        $($('.modal-content', this.getUIElement())[0]).empty().append(elements);
        return this;
    }

    /**
     * Set the content for this modal's footer
     * @param elements {jQuery}
     * @return {Modal} this modal
     */
    setFooterContent(elements) {
        $($('.modal-footer', this.getUIElement())[0]).empty().append(elements);
        return this;
    }

    /**
     * Get the content of this modal
     * @return {jQuery}
     */
    getContent() {
        return $($('.modal-content', this.getUIElement())[0]);
    }

    getCode() {
        return this.id;
    }

    close() {
        this.hide();
    }

    getContentWidth(){
        return $($('.modal-content', this.getUIElement())[0]).width();
    }
    isSmallContentWidth(){
        return this.getContentWidth() < MAX_SMALL_WIDTH_THRESHOLD;
    }
    getContentHeight(){
        return $($('.modal-content', this.getUIElement())[0]).height();
    }
    isSmallContentHeight(){
        return this.getContentHeight() < MAX_SMALL_HEIGHT_THRESHOLD;
    }
    getContentAbsolutePosition(){
        return $($('.modal-content', this.getUIElement())[0]).offset();
    }
}

/**
 * A modal window that fills the whole application (some margin is left out)
 * @extends Modal
 */
class ModalFull extends Modal {

    /**
     *
     * @param target {jQuery} The target element to append the modal to
     * @param id {string} Panel id
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     */
    constructor(target, id, onChangeRuntimeConfig=undefined) {
        super(target, id, onChangeRuntimeConfig, false);
    }

    getClassName() {
        return "ModalFull";
    }

    getModalClasses() {
        return 'full';
    }
}

/**
 * A modal window that fills the whole application with no margins
 * @extends Modal
 */
class ModalFullNoMargin extends Modal {

    /**
     *
     * @param target {jQuery} The target element to append the modal to
     * @param id {string} Panel id
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     * @param hasFooter {boolean} should a footer be rendered for this modal?
     */
    constructor(target, id, onChangeRuntimeConfig = undefined, hasFooter=false) {
        super(target, id, onChangeRuntimeConfig, false, hasFooter);
    }

    getClassName() {
        return "ModalFullNoMargin";
    }

    getModalClasses() {
        return 'full-no-margin';
    }
}

/**
 * A modal window that fills half of the application
 */
class ModalHalf extends Modal {

    getClassName() {
        return "ModalHalf";
    }

    smallScreenClasses = 'two-thirds';
    largeScreenClasses = 'half';

    onSmallContainer() {
        super.onSmallContainer();
        this.getUIElement()
            .removeClass(this.smallScreenClasses)
            .removeClass(this.largeScreenClasses)
            .addClass(this.getModalClasses());
    }

    getModalClasses() {
        return this.isSmallContainerWidth || this.isSmallContainerHeight
            ? this.smallScreenClasses
            : this.largeScreenClasses;
    }
}

/**
 * A modal window that fills half of the application with no deactivation of content
 */
class ModalHalfNoDeactivation extends Modal {

    getClassName() {
        return "ModalHalfNoDeactivation";
    }

    getModalClasses() {
        return 'half-no-deactivation';
    }
}

/**
 * A modal window that fills a third of the application
 * @extends Modal
 */
class Modal1Third extends Modal {

    getClassName() {
        return "Modal1Third";
    }

    smallScreenClasses = 'two-thirds';
    largeScreenClasses = 'one-third';

    onSmallContainer() {
        super.onSmallContainer();
        this.getUIElement()
            .removeClass(this.smallScreenClasses)
            .removeClass(this.largeScreenClasses)
            .addClass(this.getModalClasses());
    }

    getModalClasses() {
        return this.isSmallContainerWidth || this.isSmallContainerHeight
            ? this.smallScreenClasses
            : this.largeScreenClasses;
    }
}

/**
 * A modal window that fills 2 thirds of the application
 * @extends Modal
 */
class Modal2Thirds extends Modal {

    getClassName() {
        return "Modal2Thirds";
    }

    smallScreenClasses = 'full';
    largeScreenClasses = 'two-thirds';

    onSmallContainer() {
        super.onSmallContainer();
        this.getUIElement()
            .removeClass(this.smallScreenClasses)
            .removeClass(this.largeScreenClasses)
            .addClass(this.getModalClasses());
    }

    getModalClasses() {
        return this.isSmallContainerWidth || this.isSmallContainerHeight
            ? this.smallScreenClasses
            : this.largeScreenClasses;
    }
}

export {
    ModalFull,
    ModalFullNoMargin,
    ModalHalf,
    ModalHalfNoDeactivation,
    Modal1Third,
    Modal2Thirds
};